import Validator from 'validatorjs';

export const checkIfEmpty = props => {
  const rules = {
    subject: 'required',
    message: 'required'
  };

  const errorMessages =  {
    'required.subject': 'Subject is required.',
    'required.message': 'Message is required.'
  };

  const validator = new Validator(props, rules, errorMessages);

  validator.passes();
  return validator.errors.all();
};
